module.exports = __webpack_public_path__ + "img/img关于仁信.ecd1f28f.png";